const redbackEnums = require("@dpdgroupuk/redback-enums");
const USER_ROLES = require("./userRoles");
const SEQUENCES_VALUE = require("./sequencesValue");
const APP_ROLES = require("./appRoles");
const INVOICE_REQUIRED = require("./invExportInvoiceRequired");
const INVOICE_TYPES = require("./invoiceTypes");
const INVOICE_TYPE = require("./invoiceTypes");
const LABEL_TYPE = require("./labelTypes");
const BUSINESS_ID = require("./business");
const UMS_TABLE = require("./umsTables");
const SHIPMENT_TYPES = require("./shipmentTypes");
const NETWORK_SERVICES = require("./networkServices");
const IMPORT_COLLECTIONS_TYPE = require("./importCollectionsType");
const REQUIRED_TYPE = require("./requiredTypes");
const BANNERS_TYPE = require("./bannersTypes");
const TEMPLATE_TYPE = require("./templateTypes");
const CUST_STATUS = require("./custStatus");

module.exports = {
  ...redbackEnums,
  BUSINESS_ID,
  REQUIRED_TYPE,
  UMS_TABLE,
  USER_ROLES,
  SEQUENCES_VALUE,
  NETWORK_SERVICES,
  APP_ROLES,
  INVOICE_REQUIRED,
  // duplicated, please use INVOICE_TYPE instead
  INVOICE_TYPES,
  INVOICE_TYPE,
  LABEL_TYPE,
  SHIPMENT_TYPES,
  IMPORT_COLLECTIONS_TYPE,
  // will be removed soon once usage will be replaced with redback-enums
  DPD_SERVICES: redbackEnums.DOM_DPD_SERVICE,
  DPD_LOCAL_SERVICES: redbackEnums.DOM_LOCAL_SERVICE,
  NETWORKS: redbackEnums.DOM_NETWORK,
  SERVICES: redbackEnums.DOM_SERVICE,
  // @duplicated
  BANNERS_TYPES: BANNERS_TYPE,
  BANNERS_TYPE,
  TEMPLATE_TYPE,
  ...require("./errorTypes"),
  ...require("./printer"),
  CUST_STATUS,
  SHIPPING_USER_TYPE: require("./shippingUserTypes"),
};
